import React from "react";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/lib/shadcn/ui/alert-dialog";
import { DeleteOptionTypeLabel } from "@/lib/shadcn/components/delete-option-confirm-dialog";

export interface BlockingApartment {
    apartmentId: number;
    apartmentName: string;
}

export interface DeleteOptionBlockedDialogProps {
    optionTypeLabel: DeleteOptionTypeLabel;
    optionName: string;
    blockingApartments: BlockingApartment[];
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

export const DeleteOptionBlockedDialog: React.FC<DeleteOptionBlockedDialogProps> = ({
    optionTypeLabel,
    optionName,
    blockingApartments,
    open,
    onOpenChange,
}) => {
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent data-testid="delete-option-blocked-dialog">
                <AlertDialogHeader>
                    <AlertDialogTitle>
                        Cannot delete {optionTypeLabel} &apos;{optionName}&apos;
                    </AlertDialogTitle>
                    <AlertDialogDescription asChild>
                        <div>
                            <p>Currently used by:</p>
                            <ul className="list-disc pl-5 space-y-1 text-sm mt-2">
                                {blockingApartments.map((apt) => (
                                    <li
                                        key={apt.apartmentId}
                                        data-testid={`blocking-apartment-${apt.apartmentId}`}
                                    >
                                        {apt.apartmentName}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogAction onClick={() => onOpenChange(false)}>OK</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default DeleteOptionBlockedDialog;
